import { createPortal } from 'react-dom';
import type { ToastState } from '../hooks/useToast';

/** Toont de melding uit useToast, met optionele actieknop (bv. "Ongedaan maken"). */
export function ToastHost({ toast, onDismiss }: { toast: ToastState | null; onDismiss: () => void }) {
  if (!toast) return null;
  return createPortal(
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-6 left-1/2 z-[140] flex max-w-[calc(100vw-2rem)] -translate-x-1/2 items-center gap-2 rounded-2xl bg-slate-900 py-2 pl-4 pr-2 text-sm font-semibold text-slate-50 shadow-2xl dark:bg-slate-100 dark:text-slate-900"
    >
      <span>{toast.text}</span>
      {toast.action && (
        <button
          onClick={() => {
            toast.action?.onClick();
            onDismiss();
          }}
          className="min-h-11 whitespace-nowrap rounded-xl bg-white/15 px-4 transition-all duration-150 active:scale-95 dark:bg-slate-900/10"
        >
          {toast.action.label}
        </button>
      )}
    </div>,
    document.body,
  );
}
